import Service from '../abstract/service'
import Empresa from '../empresa'

export default class ProdutoFroca extends Service {
  constructor() {
    super()
    this._produtoForcaRef = this._db.collection(
      `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/ProdutoForca`
    )
    this._dataSyncRef = this._db.collection(
      `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/DataSync`
    )
    this._serviceEmpresa = new Empresa()
  }

    async create(values) {
    try {
      this._loading.setLoading(true, 'Cadastrando Produto Força')
      let doc = await this._produtoForcaRef.doc()
      await doc.set(values)
      values.id = doc.id

      return Promise.resolve(values)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async update(produtoId, values) {
    try {
      this._loading.setLoading(true, 'Atualizando Dados do Produto Força')
      delete values.id
      const produto = await this._produtoForcaRef.doc(produtoId)
      produto.update({
        ...values
      })

      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async getAll() {
    try {
      this._loading.setLoading(true, 'Buscando Produtos Força')
      const response = await this._produtoForcaRef.get()

      let produto = new Array()
      if (!response.empty) {
        for (let doc of response.docs) {
          produto.push({
            id: doc.id,
            ...doc.data()
          })
        }
      }

      return Promise.resolve(produto)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async getByEmpresa(empresa) {
    try {
      this._loading.setLoading(true, 'Buscando Produtos Força')

      const response = await this._produtoForcaRef
        .where("empresas", "array-contains", empresa)
        .get()

      let produto = new Array()

      if (!response.empty) {
        for (let doc of response.docs) {
          produto.push({
            id: doc.id,
            ...doc.data()
          })
        }
      }
      return Promise.resolve(produtosForca)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async getByFabricanteAndAtivo(fabricante, ativo) {
    try {
      this._loading.setLoading(true, 'Buscando Produtos Força')
      const response = await this._produtoForcaRef
        .where('fabricante', '==', fabricante)
        .where('ativo', '==', ativo)
        .get()
      let produto = new Array()

      if (!response.empty) {
        for (let doc of response.docs) {
          produto.push({
            id: doc.id,
            ...doc.data()
          })
        }
      }
      return Promise.resolve(produto)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async getByNome(nomes) {
    try {
      this._loading.setLoading(true, 'Buscando Produtos Força')
      const response = await this._produtoForcaRef
        .where('descricao', 'in', nomes)
        .get()

      let produtoForca = new Array()
      if (!response.empty) {
        for (let doc of response.docs) {
          produtoForca.push({
            id: doc.id,
            ...doc.data()
          })
        }
      }
      return Promise.resolve(produtoForca)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async desativaSincronizacaoAntiga() {
    try {
      const response = await this._dataSyncRef.where('ativo', '==', true)
        .where('descricao', '==', 'Produto Força')
        .get()
      if (!response.empty) {
        const [doc] = response.docs
        const sincAntiga = await this._dataSyncRef.doc(doc.id)
        await sincAntiga.update({ ativo: false })
      }
      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async criaSincronizacao(fabricante) {
    try {
      const empresas = await this._serviceEmpresa.getByFabricante(fabricante)
      this._loading.setLoading(true, 'Gerando Sincronização')

      await this.desativaSincronizacaoAntiga()
      await this._dataSyncRef.doc().set({
        ativo: true,
        dataCriacao: new Date(),
        descricao: 'Produto Força',
        empresas: empresas.map(empresa => empresa.cnpj)
      })
      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

}
